import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/_layout/new-password")({
  beforeLoad: ({ search }) => {
    const token = (search as any)?.token || "";
    throw redirect({
      to: "/auth/password-reset",
      search: { token },
    });
  },
  component: () => null,
});
